package utils.logger

import ru.malygin.BuildConfig
import ru.malygin.myConst.OnTopVariable
import ru.malygin.myConst.jsMainDebugUnit

@Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")
actual object log {
    actual fun d(message: Any) {
        console.log(message)
    }
    actual fun i(message: Any) {
        console.info(message)
    }
    actual fun w(message: Any) {
        console.warn(message)
    }
    actual fun e(message: Any) {
        jsMainDebugUnit {
            console.error(message)
        }
    }
}